export default `
<div class="feed-item-info" >
  <a class="profile-thumb" bg-img="{{match.label.avatar_url}}"></a>
  <a>{{match.label.name}}</a>
  <small>
    {{match.label.slug}}
  </small>
</div>
`;
